// extracted by mini-css-extract-plugin
export default {"title":"style-title-3_rXe","standard":"style-standard-285vb","fullscreen":"style-fullscreen-5ms3z style-standard-285vb","scrolly":"style-scrolly-1ekoS"};